import containerFuild from '../html-snippets/container-fuild';
import dividerPrimary from '../../../views/website/products/components/description/ui-modules/divider-primary/raw-html.js';
import css from '../css-snippets/section-slider-fastvaluedeal-01.js';
const dividerPrimaryHtml = dividerPrimary({
  show: true,
  maxWidth: 200,
  height: 6,
  align: 'center',
  backgroundColor: '#5b04de',
});

const itemSlideHtml = ({ imgSrc, title, description }) => `
<div data-attribute="item" class="swiper-slide">
            <div class="wrap-item">
              <div class="wrap-image">
                <img
                  data-attribute="image-item"
                  src="${imgSrc}"
                  alt=""
                />
              </div>
              <div data-attribute="content-item" class="wrap-content">
                <h3>${title}</h3>
                <p><span style="color:hsl( 0, 1%, 46% );">${description}</span></p>
              </div>
            </div>
          </div>`;

const html = `
<div class="container">
  <div class="wrap-card">
    <div class="card-heading">
      <div data-show="true" data-attribute="card-title" class="card-title">
        <h2 style="text-align: center;"><strong>Expand Your Entertainment With WaveMax</strong></h2>
        <p style="text-align: center;">Description</p>
      </div>
      ${dividerPrimaryHtml}
      <div data-show="true" data-attribute="card-summary" class="card-summary">
        <p style="text-align:center;"><span style="color:hsl( 0, 1%, 46% );">Cable television has become the most outdated home entertainment option in the past few years. Forget limited
        channel options and high fees – it’s time for an upgrade with WaveMax.</span></p>
      </div>
    </div>
    <div class="wrap-list-items">
      <div class="swiper">
        <div data-attribute="list-item" data-col-per-view="4" data-space-between="20" class="swiper-wrapper">
          ${itemSlideHtml({
            imgSrc: 'https://cdn.skyfastimg.com/images/2026/06/01/image-6a1d3b66455a27b728166c08.jpg',
            title: 'Unlimited Channel Selection',
            description:
              'There is endless content out there. Most cable companies rarely offer more than a few dozen channels. With WaveMax, there are no limits to your new channel selection.',
          })}
          ${itemSlideHtml({
            imgSrc: 'https://cdn.skyfastimg.com/images/2026/06/01/image-6a1d3b6c748b7264b374b1cc.jpg',
            title: 'No Expensive Subscriptions',
            description:
              'Home entertainment has never been cheap. WaveMax is putting an end to overpriced cable service – with no fees and subscriptions, you can leave overspending in the past.',
          })}
          ${itemSlideHtml({
            imgSrc: 'https://cdn.skyfastimg.com/images/2026/06/01/image-6a1d3b714b5ef972edc2a112.jpg',
            title: 'Take It With You Anywhere',
            description:
              'Have you ever wished you could take your TV with you while traveling? Thanks to WaveMax lightweight design, you can enjoy limitless entertainment anywhere.',
          })}
          ${itemSlideHtml({
            imgSrc: 'https://cdn.skyfastimg.com/images/2026/06/01/image-6a1d3b756615b40ba4e604d6.jpg',
            title: 'Extra-Strong Signal Quality',
            description:
              'WaveMax is designed to maintain the strongest, interruption-free signal, even with poor weather, maintenance work, and a cat sitting on the wrong wire!',
          })}
        </div>
      </div>
      <div class="wrap-pagination">
        <div class="swiper-pagination"></div>
        <div class="swiper-button-next"></div>
        <div class="swiper-button-prev"></div>
      </div>
    </div>
  </div>
</div>
`;

export default containerFuild(html, css);
